export class GridViewOptions {
    UseAvatars: boolean;
    SingleLineDisplay: boolean;
    ResultLineDisplay: boolean;
    /**Option to hide duplicate rows in the table (by row ID field) */
    HideDuplicatesOption: boolean;
    InlineEdit: boolean;
}